<template>
  <div class="background">
    <div style="font-size:0;">-->
      <img src="
http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2Lb4S0d6.jpg" width="100%" />
    </div>
    <div style="padding:0.5rem 0;">
      <div class="inputForm">

        <van-field v-model="query.certificateName" placeholder="请填写姓名" label="姓名" clearable/>
        <van-field v-model="query.mobilePhone" placeholder="请填写联系电话" label="联系电话" clearable/>
        <van-field v-model="query.area"  label="所在地区" placeholder="请选择省、市、区" clearable @click="showArea=true"/>
        <van-field v-model="query.address" label="详细地址" placeholder="街道/镇+村/小区/写字楼+门牌号" clearable/>
        <div style="color: rgb(240, 0, 0); margin: 0.16rem 0px 0.08rem; text-align: center;"> 本人可收货详细地址，精确到门牌号 </div>
        <div style="color: rgb(102, 102, 102); text-align: center;"> *请填写真实身份信息，联系电话错误、收货地址错误或过于简单无法正常发货，收货地址请填写完整。 </div>
        <van-button type="success" size="large" round @click="submit" class="submit-btn" style="margin-top:0.5rem;">微信支付59元，包邮到家</van-button>

      </div>
    </div>


    <div style="font-size:0;">
      <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2Lb4S0YN.jpg" width="100%" />
    </div>


    <van-popup v-model="showArea" position="bottom">
      <van-picker show-toolbar title="地区选择" :columns-num="3" :columns="areaInfo" @confirm="onAreaConfirm" @cancel="showArea=false"/>

    </van-popup>


  </div>
</template>

<script>
import saasAPI from '@/api/saas';
import wxpayAPI from '@/api/wxpay';
import areaJson from '@/assets/pcas-code.json'

export default {
  data() {
    return {
      isShow:false,
      checked:true,
      linkNum:"hD07woHH",
      query: {
        pid: this.$route.query.pid,
        jobId: this.$route.query.jobId
      },
      areaTreeList: [],
      showArea: false,
      showProtocol: false,
      phoneList: [],
      phoneNumberList: [],
      showPhone: false,
      protocol: '',
      showAppList: false,
      appList: '',
      areaInfo: areaJson,
      showPhone1:false,
      showPresnal:false,
      callbackExtInfo:''

    }
  },
  methods: {
    select(val){
      this.query.phone=val;
      this.showPhone = false;
      this.query.orderMobile = val;

      console.log(val);

    },
    repaceinfo(v){
      let res=new RegExp("("+this.query.numberKeyword+")",'g');

      let a=v.replace(res,"<span style='color:red'>"+this.query.numberKeyword+"</span>")
      return a
    },
    onSearch(val) {
      this.openPhonePopup()
    },
    onCancel() {

    },
    onAreaConfirm(value, index) {
      this.showArea = false;
      this.query.area = value.join(" ");
      let province = this.areaInfo[index[0]];
      let city = province.children[index[1]];
      let district = city.children[index[2]];
      this.query.sendProvinceCode = province.code;
      this.query.sendCityCode = city.code;
      this.query.sendDistrictCode = district.code;

      console.log(this.query)
    },

    openProtocol() {
      this.showProtocol = true;

    },
    onshowPresnal(){
      this.showPresnal=true;
    },
    submit() {

      if (!this.query.pid) {
        this.$toast("链接参数有误Pid");
        return;
      }
      if (!this.query.jobId) {
        this.$toast("链接参数有误Job");
        return;
      }
      if (!this.query.certificateName
          || !this.query.sendProvinceCode || !this.query.sendCityCode || !this.query.sendDistrictCode
          || !this.query.address || !this.query.mobilePhone) {
        this.$toast("请先填写相关信息");
        return;
      }
      if (!this.$myUtil.mobile(this.query.mobilePhone)) {
        this.$toast("请输入正确的手机号");
        return;
      }

      console.log(this.query)
      let jobId=this.$route.query.jobId;
      let address=this.query.area+this.query.address
      //address去空格
      address=address.replace(/\s+/g,"");
      let param={
        openId: this.$route.query.openId,
        jobId:jobId,
        name: this.query.certificateName,
        tel: this.query.mobilePhone,
        address:address,
        jobCount:1,
        amount:0,
        goodsId:0,
        goodsDepositCount:0,
        orderType:1,
        pid:this.query.pid
      }
      console.log('--init pay--')
      console.log(param)
      this.charge(param)
      console.log('--init pay end--')




    },

    charge(item2) {

      if (!item2.jobId) {
        this.$toast("参数不对,请重新进入");
        return;
      }

      this.$toast.loading({forbidClick: true});
      wxpayAPI.charge(item2).then((result) => {
        this.$toast.clear();
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(result.data), false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(result.data));
            document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(result.data));
          }
        } else {
          this.onBridgeReady(result.data);
        }
      }).catch(() => {
      });
    },
    onBridgeReady(data) {
      // 根据返回参数跳转微信支付页面
      WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            "appId": data.appId,          //公众号名称，由商户传入
            "timeStamp": data.timeStamp,  //时间戳，自1970年以来的秒数
            "nonceStr": data.nonceStr,    //随机串
            "package": data.package,      //订单详情扩展字符串
            "signType": data.signType,    //微信签名方式：
            "paySign": data.paySign,      //微信签名
          },
          function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
              alert('支付成功');
              // 使用以上方式判断前端返回,微信团队郑重提示：
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            }
          }
      );
    },
  },
  created() {

    let areaTree = this.areaInfo;
    if (areaTree) {
      areaTree.map(e => {
        e.text = e.name;

        if (e.children) {
          e.children.map(e2 => {
            e2.text = e2.name;

            if (e2.children) {
              e2.children.map(e3 => {
                e3.text = e3.name;
              })
            }
          })
        }
      });
      //console.log(areaTree)
      this.areaInfo = areaTree;
    }


  },
}

</script>

<style lang="scss" scoped>
.background {
  background-size: 100% 100%;
  padding-top: 0rem;
  text-align: center;
  background-color: #03051c;
}

.inputForm {
  background-color: white;
  width: 85%;
  margin: 0 auto;
  border-radius: 1rem;
  padding: 0.5rem 1rem;
  text-align: center;

  .van-cell{
    margin-top: 0.5rem;

    /* padding: 0 0.16rem 0 0.32rem; */
    -webkit-box-shadow: inset 0 0 0 1px #b81e20;
    box-shadow: inset 0 0 0 1px #07c160;
    border-radius: 0.4rem;
    /* font-size: 0.28rem; */
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }
}
.form-tips {
  color: #999;
  font-size: 1.3rem;
  margin: 0.8rem 0;
  text-align: center;

}
.submit-btn {
  color: #fff;
  border: 0px;
  background-color: #07c160;
  animation: focus 1s infinite;
  line-height: 4rem;
  height: 4rem;
  font-size: 2rem;

}

.phone{
  span{
    color: red;
  }
}
.tel-number-x {
  display: flex;
  flex-wrap: wrap;
}
.tel-number {
  width: 40%;
  margin-bottom: 0.5rem;
  font-weight: 700;
  padding-left: 2rem;
  margin-top: 1rem;
  .items-center {
    align-items: center;
  }
  .flex {
    display: flex;
  }
  .hot-icon {
    width: 1.5rem;
    height: 1.3rem;
    margin-left: 0.2rem;
  }
  .butok{
    color: rgb(255, 0, 0);
    text-align: left;
    font-size: 1.2rem;
  }
}
.reload-tel-number-btn {
  background-color: #b81e20;
  color: #fff;
  border-radius: 0.3rem;
  width: 2.4rem;
  height: 0.7rem;
  display: block;
  margin: 0.3rem auto 0.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
@-webkit-keyframes focus {
  0% {
    transform: scale(.9);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(.9);
  }
}
@keyframes focus {
  0% {
    transform: scale(.9);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(.9);
  }
}
.view-router{
  padding-bottom: 0px;
}



</style>
